import { noteConstants } from "../_constants";

export function note(state = {}, action) {
  switch (action.type) {
  case noteConstants.WORKING_NOTE_ID:
    return {
      ...state,
      id: action.id
    };
  case noteConstants.WORKING_NOTE_LOCATION:
    return {
      ...state,
      location: action.location
    };
  case noteConstants.SELECTED_NOTE:
    return {
      ...state,
      selectedNote: action.list
    };
  case noteConstants.NOTE_PERMISSION:
    return {
      ...state,
      notePermission: action.permission
    };
  case noteConstants.NOTE_CREATE_PERMISSION:
    return {
      ...state,
      noteCreatePermission: action.permission
    };
  case noteConstants.NOTE_VIEW_PERMISSION:
    return {
      ...state,
      noteViewPermission: action.permission
    };
  case noteConstants.NOTE_MERGE_PERMISSION:
    return {
      ...state,
      noteMergePermission: action.permission
    };
  case noteConstants.NOTE_BULK_RESOLVE_PERMISSION:
    return {
      ...state,
      noteBulkResolvePermission: action.permission
    };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/note.reducer.js